import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';

import CnpjFormatter from './cnpj-formatter';
import DomainFormatter from './domain-formatter';
import PreventFutureDateFormatter from './prevent-future-date-formatter';

registerFormatter('cnpj', CnpjFormatter);
registerFormatter('domain', DomainFormatter);
registerFormatter('prevent-future-date', PreventFutureDateFormatter);
